import styled from 'styled-components'

export const Container = styled.section`
    position: relative;
    width: 100vw;
    background-color: rgba(244, 245, 247, 1);
`;